/* eslint-disable import/prefer-default-export */
export const eventCriticalPointLegend = [
  {
    value: '$PRE_5M_AVG$',
    desc: '직전 5분 통계 평균 값',
  },
  {
    value: '$PRE_5M_MAX$',
    desc: '직전 5분 통계 최대 값',
  },
  {
    value: '$PRE_5M_MIN$',
    desc: '직전 5분 통계 최소 값',
  },
  {
    value: '$PREDICT$',
    desc: '동일시간 대 성능 예측 값',
  },
];



// WEBPACK FOOTER //
// ./src/constants/event.js